/**
 * Who runs the service, for the legal pages.
 *
 * These are the only real-world identifiers on the site — the legal texts
 * themselves live in the catalogues and speak of "the Operator" so the same
 * wording holds in three languages. A sole trader's entry, as CEIDG holds it;
 * a change here is a change to who the contract is with, so it moves
 * `LEGAL_UPDATED` too.
 */
export const OPERATOR = {
  /** Legal name of the person or company running the service. */
  name: "Yan Lypnytskyi",
  /** Registered address, one line. */
  address: "al. Jerozolimskie 109 lok. 70, 02-011 Warszawa, Polska",
  /** Polish tax and statistical numbers, or "" to hide the line. */
  nip: "1251790336",
  regon: "542151676",
  /** Where notices, data requests and complaints are sent — and every other
   *  question: `/kontakt` and the account page print this same address. */
  email: "contact@polskiegzamin.pl",
} as const;

/** The date printed at the top of every legal page. Bump it when the text changes. */
export const LEGAL_UPDATED = "2026-10-15";
